import React, { useState, useEffect } from "react";
import "../Admin/table.css"
import { toast, ToastContainer } from "react-toastify";
import { Form, Select, Input, DatePicker, TimePicker, Button } from 'antd';
import moment from 'moment';
import { Row, Col } from 'antd';
import Multiselect from "multiselect-react-dropdown";
import loader from "../../Images/ajax-loader.gif";
import { getDistrict, show_resource_detail, getBlockByDistrict, getVillageByBlock, schedule_meeting_api } from "../../api/User";
const MahilaSabhaMetting = ({ }) => {
  const { Option } = Select;
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [villages, setVillages] = useState([]);
  const [showMemberDetails, setShowMemberDetails] = useState(false);
  const userId = sessionStorage.getItem("user_id");
  const [token, setToken] = useState(sessionStorage.getItem("token") || "");
  console.log("selected value", selectedOptions)
  const [selectedFileNames, setSelectedFileNames] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [selectedResourceTypes, setSelectedResourceTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSaveButtonClicked, setIsSaveButtonClicked] = useState(false);
  const [formData, setFormData] = useState({
    uploadfile: null,
    district: '',
    block: '',
    gram_panchayat: '',
    panchayatSecretaryName: '',
    sarpanchMobile: '',
    panchayatAddress: '',
    facilitator: '',
    sabhaDate: null,
    startTime: null,
    sarpanchName: '',
  });

  const [errors, setErrors] = useState({
    distric: false,
    block: false,
    gram_panchayat: false,
    sabhaDate: false,
    facilitator: false,
    panchayatSecretaryName: false,
    panchayatSecretaryMobile: false,
    sarpanchName: false,
    sarpanchMobile: false,
    panchayatAddress: false,
    panchayatPinCode: false,
    uploadfile: false,
    startTime: false,
    endTime: false,
    dateRange: false,
  });

  const handleChange = (name, value, date) => {
    if (moment.isMoment(value)) {
      value = value.toISOString();
    }

    if (typeof value === 'string') {
      if (name === "panchayatSecretaryName") {
        if (value === "") {
          setFormData((prevState) => ({
            ...prevState,
            panchayatSecretaryName: value,
          }));
          setErrors(prev => ({ ...prev, [name]: false }));
          return;
        }
        value = value.toUpperCase();

        if (value.charAt(0) === " ") {
          setErrors(prev => ({ ...prev, [name]: "Presiding Officer Name cannot start with a space." }));
          return;
        }

        setFormData((prevState) => ({
          ...prevState,
          panchayatSecretaryName: value,
        }));

        if (value.length === 0) {
          setErrors(prev => ({ ...prev, [name]: "Presiding Officer Name cannot be empty or just spaces." }));
        } else {
          setErrors(prev => ({ ...prev, [name]: false }));
        }
        return;
      }
      if (name === "sarpanchName") {
        if (value === "") {
          setFormData((prevState) => ({
            ...prevState,
            sarpanchName: value,
          }));
          setErrors(prev => ({ ...prev, [name]: false }));
          return;
        }
        value = value;

        if (value.charAt(0) === " ") {
          setErrors(prev => ({ ...prev, [name]: "Presiding Officer Designation cannot start with a space." }));
          return;
        }

        setFormData((prevState) => ({
          ...prevState,
          sarpanchName: value,
        }));

        if (value.length === 0) {
          setErrors(prev => ({ ...prev, [name]: "Presiding Officer Designation cannot be empty or just spaces." }));
        } else {
          setErrors(prev => ({ ...prev, [name]: false }));
        }
        return;
      }

      if (name === "panchayatAddress") {

        if (value === "") {
          setFormData((prevState) => ({
            ...prevState,
            panchayatAddress: value,
          }));
          setErrors(prev => ({ ...prev, [name]: false }));
          return;
        }

        value = value;

        if (value.charAt(0) === " ") {
          setErrors(prev => ({ ...prev, [name]: "Venue cannot start with a space." }));
          return;
        }

        setFormData((prevState) => ({
          ...prevState,
          panchayatAddress: value,
        }));

        if (value.length === 0) {
          setErrors(prev => ({ ...prev, [name]: "Venue cannot be empty or just spaces." }));
        } else {
          setErrors(prev => ({ ...prev, [name]: false }));
        }
        return;
      }
      if (name === "sarpanchMobile") {
        const isNumber = /^[1-9]\d*$/.test(value);
        if (value && (!isNumber || value.length > 10)) {
          return;
        }
      }
      if (name === "sarpanchMobile") {
        const isNumber = /^[1-9]\d{0,9}$/.test(value);
        setFormData((prevState) => ({
          ...prevState,
          sarpanchMobile: value,
        }));
        if (value && (!isNumber || value.length > 10)) {
          setErrors(prev => ({ ...prev, [name]: true }));
        } else {
          setErrors(prev => ({ ...prev, [name]: false }));
        }
      }
      else if (name === "file") {
        const file = value[0];
        if (file) {
          setFormData(prevData => ({
            ...prevData,
            uploadfile: file,
          }));
        }
      }
    }
    setFormData(prevState => ({
      ...prevState,
      [name]: value,
    }));

    if (name === "district") {
      setFormData((prevState) => ({
        ...prevState,
        district: value,
        block: "",
        gram_panchayat: "",
      }));
      setBlocks([]);
      setVillages([]);
      fetchBlocks(value);

      setErrors((prevErrors) => ({
        ...prevErrors,
        district: value ? '' : 'District is required',
      }));
    }
    else if (name === "block") {
      const district_code = formData.district;
      fetchVillages(district_code, value);
      setFormData((prevState) => ({
        ...prevState,
        block: value,
        gram_panchayat: "",
      }));
      setVillages([]);
      setErrors((prevErrors) => ({
        ...prevErrors,
        block: value ? '' : 'Block is required',
      }));
    }
    else if (name === "gram_panchayat") {
      setFormData((prevState) => ({
        ...prevState,
        gram_panchayat: value,
      }));
      setErrors((prevErrors) => ({
        ...prevErrors,
        gram_panchayat: value ? '' : 'Gram Panchayat is required',
      }));
    }

    else {
      setFormData(prevData => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleFinish = async () => {

    const formDataToSend = new FormData();
    formDataToSend.append("file", formData.uploadfile);
    formDataToSend.append("district_code", formData.district);
    formDataToSend.append("block_code", formData.block);
    formDataToSend.append("gram_panchayat_code", formData.gram_panchayat);
    formDataToSend.append("sabha_date", formData.sabhaDate);
    formDataToSend.append("start_time", formData.startTime);
    formDataToSend.append("presiding_officer_name", formData.panchayatSecretaryName);
    formDataToSend.append("presiding_officer_mobile", formData.sarpanchMobile);
    formDataToSend.append("venue", formData.panchayatAddress);
    formDataToSend.append("presiding_officer_designation", formData.sarpanchName);
    formDataToSend.append("user_id", userId);
    formDataToSend.append("meeting_type", "mahila_sabha");
    if (Array.isArray(formData.facilitator) && formData.facilitator.length > 0) {

      formData.facilitator.forEach((id) => {
        formDataToSend.append("facilitator[]", id);
      });
    }

    try {
      await schedule_meeting_api(token, formDataToSend);
      toast.success("Record Inserted Successfully", { autoClose: 1000 });
      handleReset();
      fetchData();
      setIsSaveButtonClicked(false);

    } catch (error) {
      console.error('Error submitting form:', error);
      toast.error('Error submitting form', { autoClose: 1000 });
    }
  };

  const fetchDataIfComplete = () => {
    const { district, block, gram_panchayat } = formData;
    if (district && block && gram_panchayat && selectedResourceTypes.length > 0) {
      fetchData();
    }
  };
  const handleReset = () => {
    setFormData({
      district: '',
      block: '',
      gram_panchayat: '',
      sabhaDate: '',
      facilitator: '',
      panchayatSecretaryName: '',
      panchayatSecretaryMobile: '',
      sarpanchName: '',
      sarpanchMobile: '',
      panchayatAddress: '',
      panchayatPinCode: '',
      uploadfile: '',
      dateRange: '',
      startTime: '',
      endTime: '',
      selectedRange: '',
      date: '',
    });
    setErrors({});
    setSelectedFileNames([]);
    setFileList([]);
    setShowMemberDetails(false);
  }

  const handleSaveAndPreview = () => {
    setLoading(true);

    const newErrors = {
      sarpanchMobile: validateMobileNo(formData.sarpanchMobile),
      district: formData.district ? "" : "District is required.",
      block: formData.block ? "" : "Block is required.",
      gram_panchayat: formData.gram_panchayat ? "" : "Gram Panchayat is required.",
      sabhaDate: formData.sabhaDate ? "" : "Sabha Date is required.",
      panchayatSecretaryName: formData.panchayatSecretaryName ? "" : "Presiding Officer Name is required.",
      sarpanchName: formData.sarpanchName ? "" : "Designation is required.",
      facilitator: formData.facilitator ? "" : "Facilitator is required.",
      panchayatAddress: formData.panchayatAddress ? "" : "Venue is required.",
      uploadfile: selectedFileNames.length > 0 ? "" : "Agenda is required.",
      startTime: formData.startTime ? "" : "Start Time is required.",
    };

    setErrors(newErrors);

    if (Object.values(newErrors).some(err => err)) {
      setLoading(false);
      return;
    }
    handleFinish();
    setIsSaveButtonClicked(true);
    setLoading(false);
  };

  const validateMobileNo = (mobile_no) => {
    if (!mobile_no) return "Mobile Number is required.";
    if (!/^\d{10}$/.test(mobile_no)) return "Mobile Number must be exactly 10 digits.";
    if (mobile_no[0] === '0') return "Mobile Number cannot start with zero.";
    if (/^0{10}$/.test(mobile_no)) return "Mobile Number cannot be all zeros.";
    return "";
  };

  const fetchDistricts = async () => {
    try {
      const res = await getDistrict(token);
      if (res.status === "success") {
        setDistricts(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching districts:", error);
      toast.error("An error occurred while fetching districts.", { autoClose: 1000 });
    }
  };

  const fetchBlocks = async (district_code) => {
    try {
      const res = await getBlockByDistrict(token, district_code);
      if (res.status === "success") {
        setBlocks(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching blocks:", error);
      toast.error("An error occurred while fetching blocks.", { autoClose: 1000 });
    }
  };

  const fetchVillages = async (district_code, block_code) => {
    try {
      const res = await getVillageByBlock(token, district_code, block_code);
      if (res.status === "success") {
        setVillages(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching villages:", error);
      toast.error("An error occurred while fetching villages.", { autoClose: 1000 });
    }
  };

  const fetchData = async () => {
    const data = {
      type: "gppft",
      district: parseInt(formData.district, 10),
      block: parseInt(formData.block, 10),
      gram_panchayat: formData.gram_panchayat,
    };
    try {
      const res = await show_resource_detail(token, data);
      console.log(res);
      if (res.status === "success") {
        setFilteredData(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("An error occurred while fetching data.", { autoClose: 1000 });
    }
  };

  useEffect(() => {
    fetchData()
    fetchDataIfComplete();
  }, [formData.district, formData.block, formData.gram_panchayat, selectedResourceTypes]);

  useEffect(() => {
    fetchData();
    fetchDistricts();
    handleReset();
  }, []);

  const handleFacilitatorChange = (selectedList) => {
    const selectedIds = selectedList.map(item => item.id);
    setFormData({ ...formData, facilitator: selectedIds });
    if (selectedIds.length > 0) {
      setErrors(prevErrors => ({ ...prevErrors, facilitator: null }));
    }
  };

  return (
    <>
      <div id="loading-coupon" style={{ display: loading ? "flex" : "none" }}>
        <img id="loading-image" src={loader} alt="Loading..." />
      </div>

      <div className="container-fluid" style={{ top: "0", left: "100", margin: "16px" }}>
        <div>
        <div>
            <h2 className="pt-10" style={{ top: "0", left: "0", margin: "16px", fontWeight: "bold" }}>
              Mahila Sabha Meeting
            </h2>
          </div>
          <Form className="mt-4" layout="vertical" onFinish={handleFinish} style={{ fontWeight: 'bold', marginLeft: "1.5%", marginRight: "1.5%", background: "#FFFFFF", padding: "30px", borderRadius: "15px", boxShadow: "0 6px 12px rgba(0, 0, 0, .4)", }}>
            <Row gutter={16} >

              <Col span={8}>
                <Form.Item label={<span style={{ fontWeight: '600', fontSize: '16px' }}> District Name{' '} <span style={{ color: formData.district && !errors.district ? 'black' : '#FF506B' }}>*</span>     </span>} help={errors.district ? 'District is required' : ''} validateStatus={errors.district ? 'error' : formData.district ? 'success' : ''}>
                  <Select id="district" value={formData.district || undefined} onChange={(value) => handleChange('district', value)}
                    placeholder={<span style={{ fontWeight: '300', color: 'black' }}>     Select District Name </span>}
                    className={`custom-input ${errors.district ? 'is-invalid' : formData.district ? 'is-valid' : ''}`}
                    style={{ height: '40px', width: '100%' }}>
                    {districts?.map((district, index) => (
                      <Option key={index} value={district.district_code}>
                        {district.district}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item label={<span style={{ fontWeight: '600', fontSize: '16px' }}>Block Name{' '}<span style={{ color: formData.block && !errors.block ? 'black' : '#FF506B' }}>*</span> </span>} help={errors.block ? 'Block is required' : ''} validateStatus={errors.block ? 'error' : formData.block ? 'success' : ''}>
                  <Select id="block" value={formData.block || undefined} onChange={(value) => handleChange("block", value)}
                    placeholder={<span style={{ fontWeight: '300', color: 'black' }}>     Select Block Name </span>}
                    className={`${errors.block ? 'is-invalid' : formData.block ? 'is-valid' : ''}`}
                    style={{ height: "40px", width: "100%" }}>
                    {blocks?.map((block, index) => (
                      <Option key={index} value={block.block_code}>
                        {block.block}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item label={<span style={{ fontWeight: '600', fontSize: '16px' }}>Gram Panchayat Name{' '}<span style={{ color: formData.gram_panchayat && !errors.gram_panchayat ? 'black' : 'red' }}>*</span> </span>} help={errors.gram_panchayat ? 'Gram Sabha is required' : ''} validateStatus={errors.gram_panchayat ? 'error' : formData.gram_panchayat ? 'success' : ''} >
                  <Select id="gram_panchayat" value={formData.gram_panchayat || undefined} onChange={(value) => handleChange("gram_panchayat", value)}
                    placeholder={<span style={{ fontWeight: '300', color: 'black' }}>Select Gram Panchayat Name </span>}
                    className={`${errors.gram_panchayat ? 'is-invalid' : formData.gram_panchayat ? 'is-valid' : ''}`}
                    style={{ height: "40px", width: "100%" }}>
                    {villages?.map((village, index) => (
                      <Option key={index} value={village.gram_panchayat_code}>
                        {village.gram_panchayat}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={8}>
                <Form.Item label={<span style={{ fontWeight: '600', fontSize: '16px' }}>Mahila Sabha Date <span style={{ color: formData.sabhaDate && !errors.sabhaDate ? 'black' : 'red' }}>*</span> </span>} help={errors.sabhaDate ? ' Mahila Sabha Date is required' : ''} className={errors.sabhaDate ? 'is-invalid' : ''} validateStatus={errors.sabhaDate ? 'error' : ''} >
                  <DatePicker value={formData.sabhaDate ? moment(formData.sabhaDate) : null}
                    onChange={(date) => {
                      handleChange("sabhaDate", date ? date.format('YYYY-MM-DD') : null);
                      if (date) {
                        setErrors((prevErrors) => ({ ...prevErrors, sabhaDate: '' }));
                      } else {
                        setErrors((prevErrors) => ({ ...prevErrors, sabhaDate: ' Mahila Sabha Date is required' }));
                      }
                    }}
                    disabledDate={(current) => current && current < moment().startOf('day')}
                    style={{ width: '100%', height: "40px" }}
                    className={`dark-placeholder form-control ${errors.sabhaDate ? 'is-invalid' : ''}`}
                  />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item label={<span style={{ fontWeight: '600', fontSize: '16px' }}>   Mahila Sabha Meeting Time <span style={{ color: formData.startTime && !errors.startTime ? 'black' : 'red' }}>*</span> </span>} help={errors.startTime ? ' Mahila Sabha Meeting Time is required' : ''} validateStatus={errors.startTime ? 'error' : ''} >
                  <TimePicker value={formData.startTime ? moment(formData.startTime, 'HH:mm') : null}
                    onChange={(time) => {
                      if (time) {
                        const selectedTime = time.format('HH:mm');
                        const currentTime = moment().format('HH:mm');

                        if (
                          moment(formData.sabhaDate).isSame(moment(), 'day') &&
                          moment(selectedTime, 'HH:mm').isBefore(moment(currentTime, 'HH:mm'))
                        ) {
                          setErrors((prevErrors) => ({ ...prevErrors, startTime: 'Meeting time cannot be in the past for today' }));
                        } else {
                          handleChange("startTime", selectedTime);
                          setErrors((prevErrors) => ({ ...prevErrors, startTime: '' }));
                        }
                      } else {
                        setErrors((prevErrors) => ({ ...prevErrors, startTime: ' Mahila Sabha Meeting Time is required' }));
                      }
                    }}
                    style={{ width: '100%', height: "40px" }}
                    className={`dark-placeholder form-control ${errors.startTime ? 'is-invalid' : ''}`}
                    format={'HH:mm'}
                    showNow={true}
                    disabledHours={() => {
                      if (moment(formData.sabhaDate).isSame(moment(), 'day')) {
                        const currentHour = moment().hour();
                        const hours = [];
                        for (let i = 0; i < currentHour; i++) {
                          hours.push(i);
                        }
                        return hours;
                      }
                      return [];
                    }}
                    disabledMinutes={(selectedHour) => {
                      if (moment(formData.sabhaDate).isSame(moment(), 'day') && selectedHour === moment().hour()) {
                        const currentMinute = moment().minute();
                        const minutes = [];
                        for (let i = 0; i <= currentMinute; i++) {
                          minutes.push(i);
                        }
                        return minutes;
                      }
                      return [];
                    }}
                  />
                </Form.Item>
              </Col>


              <Col span={8}>
                <Form.Item label={<span style={{ fontWeight: '600', fontSize: '16px' }}> Presiding Officer Name <span style={{ color: formData.panchayatSecretaryName && !errors.panchayatSecretaryName ? 'black' : 'red' }}>*</span>     </span>}
                  help={errors.panchayatSecretaryName ? 'Presiding Officer Name is required' : ''}
                  validateStatus={errors.panchayatSecretaryName ? 'error' : formData.panchayatSecretaryName ? 'success' : ''}>
                  <Input id="panchayatSecretaryName" className="dark-placeholder form-control" value={formData.panchayatSecretaryName} onChange={(e) => handleChange("panchayatSecretaryName", e.target.value.replace(/[^a-zA-Z\s]/g, ''))} placeholder="Enter Presiding Officer Name" style={{ height: "40px" }} placeholderStyle={{ fontWeight: '600' }} />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={8}>
                <Form.Item label={<span style={{ fontWeight: '600', fontSize: '16px' }}>Presiding Officer Designation<span style={{ color: formData.sarpanchName && !errors.sarpanchName ? 'black' : '#FF506B' }}>*</span> </span>}
                  help={errors.sarpanchName ? 'Presiding Officer Designation is required' : ''}
                  validateStatus={errors.sarpanchName ? 'error' : formData.sarpanchName ? 'success' : ''}>
                  <Input className="dark-placeholder form-control" value={formData.sarpanchName} onChange={(e) => handleChange("sarpanchName", e.target.value)} placeholder="Enter Presiding Officer Designation" style={{ height: "40px" }} />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item label={<span style={{ fontWeight: '600', fontSize: '16px' }}>Presiding Officer Mobile No <span style={{ color: formData.sarpanchMobile && !errors.sarpanchMobile ? 'black' : '#FF506B' }}>*</span>    </span>}
                  help={errors.sarpanchMobile ? 'Presiding Officer Mobile No is required and must be a valid number' : ''}
                  validateStatus={errors.sarpanchMobile ? 'error' : formData.sarpanchMobile ? 'success' : ''}>
                  <Input className="dark-placeholder form-control" value={formData.sarpanchMobile} onChange={(e) => handleChange("sarpanchMobile", e.target.value)} placeholder="Enter Presiding Officer Mobile No" style={{ height: "40px" }} />
                </Form.Item>
              </Col>

              <div className="col-md-4">
                <label htmlFor="facilitator" style={{ fontSize: "1rem", fontWeight: "bold" }} className={`form-label ${errors.facilitator ? 'is-invalid' : ''}`}>
                  Facilitator Name <span style={{ color: formData.facilitator && !errors.facilitator ? 'black' : '#FF506B' }}>*</span>
                </label>

                <Multiselect
                  options={filteredData.map((item) => ({
                    ...item,
                    displayValue: `${item.full_name} - ${item.mobile_no}`,
                  }))}
                  selectedValues={filteredData
                    .filter((item) => formData.facilitator.includes(item.id))
                    .map((item) => ({
                      ...item,
                      displayValue: `${item.full_name} - ${item.mobile_no}`,
                    }))}
                  className={` ${errors.facilitator ? 'is-invalid' : ''}`}
                  onSelect={handleFacilitatorChange}
                  onRemove={handleFacilitatorChange}
                  displayValue="displayValue"
                  placeholder="Select Facilitator Name"
                  id="facilitator"
                  name="facilitator"
                  style={{ chips: { background: "lightgray" }, searchBox: { border: errors.facilitator ? "1px solid red" : "1px solid #ced4da", borderRadius: "0.25rem", fontSize: "0.9rem", }, }} />
                {errors.facilitator && <div className="invalid-feedback">Facilitator Name is required.</div>}
              </div>
            </Row>

            <Row gutter={16}>
              <Col span={8}>
                <Form.Item label={<span style={{ fontWeight: '600', fontSize: '16px' }}>Venue <span style={{ color: formData.panchayatAddress && !errors.panchayatAddress ? 'black' : '#FF506B' }}>*</span></span>} help={errors.panchayatAddress ? 'Venue is required and cannot start with a space' : ''} validateStatus={errors.panchayatAddress ? 'error' : formData.panchayatAddress ? 'success' : ''}>
                  <Input className="dark-placeholder form-control" value={formData.panchayatAddress} onChange={(e) => handleChange("panchayatAddress", e.target.value)} placeholder="Enter Panchayat Address" style={{ height: "40px" }} />
                </Form.Item>
              </Col>

              <Col span={8}>
                <div className="form-group">
                  <label className="mt-1" style={{ fontWeight: '600', fontSize: '16px', color: 'black', marginBottom: '8px', }}>
                    Upload Agenda <span style={{ color: formData.uploadfile && !errors.uploadfile ? 'black' : '#FF506B' }}>*</span>
                  </label>

                  <input type="file" accept=".pdf,.docx" multiple
                    onChange={(e) => {
                      const files = Array.from(e.target.files);
                      const isValid = files.every(
                        (file) =>
                          file.type === 'application/pdf' ||
                          file.type ===
                          'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                      );

                      if (!isValid) {
                        setErrors((prev) => ({
                          ...prev,
                          uploadfile: 'Only PDF and DOCX files are allowed.',
                          fileEmpty: '',
                        }));
                      } else if (files.length) {
                        const fileNames = files.map((file) => file.name);
                        setSelectedFileNames(fileNames);
                        setFileList(files);
                        handleChange('file', files);
                        setFormData((prevData) => ({
                          ...prevData,
                          uploadfile: files[0],
                        }));
                        setErrors((prev) => ({ ...prev, uploadfile: '', fileEmpty: '' }));
                      } else {
                        setErrors((prev) => ({
                          ...prev,
                          fileEmpty: 'Agenda is required',
                        }));
                      }
                    }}
                    style={{ display: 'none' }}
                    id="fileUpload"
                  />

                  <label htmlFor="fileUpload" className="btn w-100" style={{ height: '40px', border: errors.uploadfile || errors.fileEmpty ? '1px solid #FF506B' : '1px solid #DEE2E6', color: 'black', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
                    Upload File
                  </label>

                  {errors.uploadfile && (
                    <div style={{ color: '#FF506B', marginTop: '4px' }}>{errors.uploadfile}</div>
                  )}

                  {selectedFileNames.length > 0 && (
                    <div>
                      <ul style={{ display: 'flex', listStyleType: 'none', padding: 0, margin: 0 }}>
                        {selectedFileNames.map((name, index) => (
                          <li key={index} style={{ marginRight: '10px' }}>{name}</li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {!selectedFileNames.length && errors.fileEmpty && (
                    <div style={{ color: '#FF506B', marginTop: '4px' }}>Agenda is required</div>
                  )}
                </div>
              </Col>
            </Row>
            <div className="row" style={{ marginTop: "20px", marginLeft: "1.5%", marginRight: "1.5%" }}>
              <div className="col text-end">
                <Button type="default" style={{ backgroundColor: "#DCE2FA", color: "#4763E4", marginRight: "10px", width: "10%", transition: "background-color 0.3s, color 0.3s" }} onMouseEnter={(e) => { e.target.style.backgroundColor = "#4763E4"; e.target.style.color = "#DCE2FA"; }} onMouseLeave={(e) => { e.target.style.backgroundColor = "#DCE2FA"; e.target.style.color = "#4763E4"; }}  onClick={handleReset}>
                  Cancel
                </Button>
                <Button type="primary" style={{ backgroundColor: "#DCE2FA", color: "#4763E4", marginRight: "10px", width: "10%", transition: "background-color 0.3s, color 0.3s" }} onMouseEnter={(e) => { e.target.style.backgroundColor = "#4763E4"; e.target.style.color = "#DCE2FA"; }} onMouseLeave={(e) => { e.target.style.backgroundColor = "#DCE2FA"; e.target.style.color = "#4763E4"; }} disabled={isSaveButtonClicked} onClick={handleSaveAndPreview}>
                  Save
                </Button>
                {/* <Button type="default" style={{ backgroundColor: "#DCE2FA", color: "#4763E4", marginRight: "10px", width: "10%", transition: "background-color 0.3s, color 0.3s" }} onMouseEnter={(e) => { e.target.style.backgroundColor = "#4763E4"; e.target.style.color = "#DCE2FA"; }} onMouseLeave={(e) => { e.target.style.backgroundColor = "#DCE2FA"; e.target.style.color = "#4763E4"; }}  >
                  Schedule
                </Button> */}
              </div>
            </div>
          </Form>


        </div>
        <ToastContainer />
      </div>
    </>
  );
};
export default MahilaSabhaMetting;
